import { Injectable } from '@angular/core';
import { CustomerOrderVerificationData } from '../../../../../../models/order/workflow/customer-order-verification.model';
import { BaseWorkflowStateService } from '../base-workflow-state.service';

@Injectable({ providedIn: 'root' })
export class CustomerOrderVerificationStateService extends BaseWorkflowStateService<CustomerOrderVerificationData> {
    protected override stateKey: string = 'customerOrderVerification';
}